webpackJsonp([66982280027447],{

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(20);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(14);
	
	__webpack_require__(13);
	
	var _reactLinkedinInsight = __webpack_require__(17);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/VandanaPai.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/KarnikaVallabh.jpg";
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/wob/4dec2025/1.png";
	var I2 = "https://www.winpeforum.com/assets/wob/4dec2025/2.png";
	var I3 = "https://www.winpeforum.com/assets/wob/4dec2025/3.png";
	var I4 = "https://www.winpeforum.com/assets/wob/4dec2025/4.png";
	var I5 = "https://www.winpeforum.com/assets/wob/4dec2025/5.png";
	var I6 = "https://www.winpeforum.com/assets/wob/4dec2025/6.png";
	var I7 = "https://www.winpeforum.com/assets/wob/4dec2025/7.png";
	var I8 = "https://www.winpeforum.com/assets/wob/4dec2025/8.png";
	var I9 = "https://www.winpeforum.com/assets/wob/4dec2025/9.png";
	var I10 = "https://www.winpeforum.com/assets/wob/4dec2025/10.png";
	var I11 = "https://www.winpeforum.com/assets/wob/4dec2025/11.png";
	var I12 = "https://www.winpeforum.com/assets/wob/4dec2025/12.png";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/1.png";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/2.png";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/3.png";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/4.png";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/5.png";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/6.png";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/7.png";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/8.png";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/9.png";
	var II10 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/10.png";
	var II11 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/11.png";
	var II12 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/12.png";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon2,
	      desc: " ",
	      name: "Karnika Vallabh",
	      post: "<div>Legal Counsel<br/>Bharucha & Partners\n\n\n\n\n          </div>"
	    }, {
	      imgUrl: icon1,
	      desc: "<div>\n \n \n          </div>",
	      name: "Vandana Pai",
	      post: "<div>Senior Partner<br/>Bharucha & Partner\n\n\n          </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }, { id: 23, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }, { id: 22, ImgSrc: I9, ImgSrc1: II9 }, { id: 19, ImgSrc: I10, ImgSrc1: II10 }, { id: 35, ImgSrc: I11, ImgSrc1: II11 }, { id: 34, ImgSrc: I12, ImgSrc1: II12 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Women on Boards",
	        image: "https://winpeforum.com/assets/wob/banner.jpg",
	        description: "Winpe\u2019s Women on Boards initiative hosted another exceptional session marked by profound insights, engaging discussions, and inspiring connections. We are pleased to report that the session received outstanding evaluations\u2014100% of participants acknowledged significant knowledge gains, and our speakers were rated exceptionally well at 4.5.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "        Winpe\u2019s Women on Boards",
	              _react2.default.createElement("br", null),
	              "Topic:  The DPDP Act - Board level Perspective"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "April 17th, 2026 (03:00 - 04:00 PM IST)",
	                  _react2.default.createElement("br", null),
	                  "Format- Virtual (Zoom)"
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "Winpe\u2019s Women on Boards initiative is reshaping board leadership by advancing high-caliber, board-ready women. Through partnerships with progressive companies and targeted board-prep programs, it offers curated talent and strategic engagement models that strengthen governance and support DEI goals.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The recent session on India's Digital Personal Data Protection Act (DPDPA) 2023 and DPDP Rules 2025, led by expert speakers, delivered a thoughtful and engaging discussion on a critical, timely topic. It resonated strongly with participants, earning outstanding feedback, high speaker ratings, and clear learning outcomes.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The session provided a focused overview of the DPDP Act, unpacking key provisions and highlighting the evolving role of boards in data privacy, risk oversight, and accountability, with an interactive format that deepened understanding and practical insight.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Catch the full recording ",
	              _react2.default.createElement(
	                "a",
	                { style: { textDecoration: 'underline', color: 'blue' }, href: "https://youtu.be/NeR87rTkTx8?si=fWspbOCbKsMvYJ5W" },
	                "here"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Join our Women on Boards community to gain access to curated board opportunities and stay informed on upcoming sessions, insights, and engagements through our WhatsApp group.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "\uD83D\uDC49 ",
	              _react2.default.createElement(
	                "a",
	                { style: { textDecoration: 'underline', color: 'blue' }, href: "https://tally.so/r/wv9OJX" },
	                "Join our peer community"
	              ),
	              "    \xA0\xA0\xA0\xA0\uD83D\uDC49          ",
	              _react2.default.createElement(
	                "a",
	                { style: { textDecoration: 'underline', color: 'blue' }, href: "https://chat.whatsapp.com/Jlema24oL2sJ2aDUUFREDa" },
	                "Join the WhatsApp Group"
	              ),
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Session Takeaways: "
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Board-Level Accountability:"
	                  ),
	                  " Data privacy must be treated as a core element of corporate governance and enterprise risk management, not merely a compliance requirement."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Consent Architecture:"
	                  ),
	                  " Organisations must implement purpose-specific, granular, and unbundled consent mechanisms, supported by clear, layered privacy notices and auditable consent records, including the ability to operationalise withdrawal of consent."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Operationalising Data Principal Rights: "
	                  ),
	                  " Systems must enable practical and efficient execution of data principal rights, including access, correction, erasure, and nomination, supported by robust data retrieval capabilities and structured grievance redressal mechanisms."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Defensible Compliance Frameworks:"
	                  ),
	                  " Compliance must be demonstrable through comprehensive documentation, embedded controls, regular audits, and strong audit trails to withstand regulatory scrutiny."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Breach Readiness & Response:"
	                  ),
	                  " Organisations should establish clear escalation protocols and ensure readiness to notify regulators and affected stakeholders within prescribed timelines, supported by forensic and reporting capabilities."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Significant Data Fiduciary (SDF) Preparedness:"
	                  ),
	                  " Organisations must proactively assess data volume, sensitivity, and risk exposure, and be prepared to implement enhanced governance measures, including Data Protection Impact Assessments (DPIAs), mandatory audits, and the appointment of a resident Data Protection Officer."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Data Lifecycle Management:"
	                  ),
	                  " Organisations must clearly distinguish between essential and optional data processing, with defined retention schedules and automated deletion or anonymisation workflows to minimise risk and liability."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Heightened Focus on Sensitive Data:"
	                  ),
	                  " Organisations handling financial, health, Aadhaar-linked, or children\u2019s data must implement enhanced safeguards and comply with overlapping sectoral regulations."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Private Equity & Portfolio Oversight:"
	                  ),
	                  " Data privacy considerations must be embedded into due diligence, valuation, and ongoing portfolio monitoring, with a focus on sector-specific risks and compliance maturity across investee companies."
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                    "Faculty"
	                  ),
	                  "          ",
	                  _react2.default.createElement("div", { "class": "r_btm" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Our_Speakers container" },
	                    _react2.default.createElement(
	                      "center",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Speakers_img", style: { width: '70%', margin: '0' } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          this.Speaker1.map(function (item, i) {
	                            if (i <= 3) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                                  key: i
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "Scardd" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "s_img",
	                                      onClick: function onClick() {
	                                        return _this3.togglePopUp(item);
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "center",
	                                      null,
	                                      "  ",
	                                      _react2.default.createElement("img", {
	                                        src: item.imgUrl,
	                                        alt: item.name,
	                                        className: "img-responsive",
	                                        style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement("br", null),
	                                  "    ",
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_name",
	                                    dangerouslySetInnerHTML: { __html: item.name }
	                                  }),
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_post",
	                                    dangerouslySetInnerHTML: { __html: item.post }
	                                  })
	                                )
	                              );
	                            } else return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-wob-the-dpdp-act-index-js-7dde8d5e090d9fcd1cc6.js